import { loganLog } from '@RootCommon/utils/logan'
import { owlAddJsError, owlAddAjaxError, owlAddResourceError, owlAddJsInfo, owlAddAjaxInfo, owlAddResourceInfo, owlReportMetrics } from '@RootCommon/utils/owl'
import { getLoginShopid, getLoginAccountId, getRegion } from '@RootCommon/utils'
import { addI18nHeader } from '@RootCommon/api/interceptors'
import { reportEvent, reportEventAll } from '../api/report'
import omS3Report from './omReports/omS3Report'

const initFunction = () => {
  // 主窗口是否已准备好
  window.electronAPI?.isMainWindowReady?.()

  // Raptor上报 注册
  window.electronAPI?.onRaptorReport?.(
    (data: {
      type: 'jsError' | 'ajaxError' | 'resourceError' | 'custom'
      level?: 'error' | 'info'
      title: string
      content: {
        [key: string]: any
      }
    }) => {
      const { type, level, title, content } = data
      const valuesDic = {
        [title]: content?.value,
      }
      const tagsDic = {
        ...content?.tags,
      }
      switch (type) {
        case 'jsError':
          level === 'error' ? owlAddJsError(valuesDic, tagsDic) : owlAddJsInfo(valuesDic, tagsDic)
          break
        case 'ajaxError':
          level === 'error' ? owlAddAjaxError(valuesDic, tagsDic) : owlAddAjaxInfo(valuesDic, tagsDic)
          break
        case 'resourceError':
          level === 'error' ? owlAddResourceError(valuesDic, tagsDic) : owlAddResourceInfo(valuesDic, tagsDic)
          break
        case 'custom':
          owlReportMetrics(valuesDic, tagsDic, {
            owlProjectName: 'com.keetapp.sailorfe.b.pc',
          })
          break
        default:
          console.error('window.electronAPI?.RaptorReport', 'unknown type', data)
          break
      }
    },
  )


  // 监听和Electron的连接
  window.electronAPI?.askConnection?.(key => {
    // console.log('window.electronAPI?.askConnection', key)
    window.electronAPI?.answerConnection?.({
      key,
      shopId: getLoginShopid() ?? -1,
      acctId: getLoginAccountId() ?? -1,
      region: getRegion() ?? '',
      commonParams: addI18nHeader({}) ?? {},
    })
  })

  // 监听自检上报
  window.electronAPI?.selfCheckReport?.(async (data: { [key: string]: any }) => {
    const res = await reportEventAll('/api/operate/appversion/om/checkInstallInfo', data)
    // hashcode 不一致 时自动上传文件
    if (res?.code === 2090002000) {
      omS3Report({
        type: 'files',
        filePathsList: res?.data?.fileList,
      })
    }
  })
}

initFunction()